export default __webpack_public_path__ + "static/media/main_1.a58041c4.jpeg";